import React, { Component } from 'react';
import OTP from './functions/otp.js';
import EmailVerification from './functions/email_verification.js';

export default class SecurityCenter extends Component {

  render() {

    const data = this.props.data;
    return (
      <div>
        <EmailVerification data={data.email_verification}/>
        <OTP data={data.otp}/>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/securitycenter.js